import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { RevertReservationsStatusComponent } from 'OpsCenter/merchants/revert-status/revert-reservations-status.component';
import RevertStatusRouter from './revert-status.router';

const revertStatusModule = angular
  .module('ec.opsCenter.revertStatus', [])
  .config(RevertStatusRouter)
  .directive('appRevertReservationsStatus', downgradeComponent({ component: RevertReservationsStatusComponent }) as angular.IDirectiveFactory).name;

export default revertStatusModule;



// WEBPACK FOOTER //
// ./src/app/merchants/revert-status/revert-status.module.ajs.ts